<script>
    import {FormValidation} from "../../../shared/directives/formValidation";
    import {LoginAPI} from "../../../apis/LoginAPI";
    import PaymentMethodForm from "../containers/PaymentMethodForm";

    export default {
        name: "ChangePasswordModal",
        data() {
            return {
                isLoading: false,
                accountFormData: {}
            }
        },
        props: ['data'],
        components: {
            PaymentMethodForm
        },
        mounted() {
        },
        methods: {

            async save() {

                this.isLoading = true;
                let resp = await this.$refs.paymentMethodForm.createPaymentMethod();
                this.isLoading = false;
                if( resp.id){
                    this.$emit('close');
                    this.$toasted.show("Payment method updated successfully.", {
                        theme: "outline",
                        position: "top-center",
                        duration: 2000,
                        className: 'falcon-toasted-success',
                    });
                }

                //
                //
                // this.isLoading = true;
                //
                // let resp = await LoginAPI.updateUserInfo(this.accountFormData.first_name, this.accountFormData.last_name);
                // if(resp.httpStatus !== 201){
                //     this.$toasted.show(resp.errors[Object.keys(resp.errors)[0]], {
                //         theme: "bubble",
                //         position: "top-center",
                //         duration: 2000,
                //         className: 'falcon-toasted',
                //     });
                // }
                // else {
                //     this.$emit('close');

                //
                // }
                // this.isLoading = false;
            }
        }
    }
</script>
<template>
    <fragment>
        <div class="modal-title">
            Payment Method
            <i class="modal-close-button" @click="$emit('close')"></i>
        </div>

        <div class="modal-body">
            <PaymentMethodForm ref="paymentMethodForm"></PaymentMethodForm>
            <div class="columns">
                <div class="column"  style="text-align: right">
                    <button class="button float-right is-primary" @click="save()" :class="{'is-loading': isLoading}">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </fragment>
</template>
<style scoped lang="scss">

</style>
